import React, { useState } from "react";
import ContentWrapper from "./ContentWrapper";
import Inputz from "../atoms/Inputz";
import Buttonz from "../atoms/Buttonz";
import { submitPasswordChange } from "../../utils/settingPasswordValidation";
import { useDispatch } from "react-redux";
import { validationPopup } from "../../redux/actions";
import CenterTitleZ from "../atoms/CenterTitleZ";

function SettingPassword({ title, icon, content }) {
  const [formData, setFormData] = useState({
    currentPassword: "",
    newPassword: "",
  });
  const [errors, setErrors] = useState({});
  const dispatch = useDispatch();

  const handleChange = (e) => {
    const { name, value } = e;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }
  };

  const handleSubmit = async () => {
    const result = await submitPasswordChange(dispatch, formData);
    if (!result.success) {
      setErrors(result.errors);
    } else {
      setFormData({ currentPassword: "", newPassword: "" }); // Clear form on success
    }
  };

  return (
    <>
      <div className="form-def-box">
      <CenterTitleZ title={title} icon={icon} content={content} className="setting-profile-title" />

        <Inputz
          iconL="password"
          iconR="ok"
          focusR="cal"
          iconOn="eye_on"
          iconOff="eye_off"
          placeholder="Current Password"
          type="password"
          name="currentPassword"
          value={formData.currentPassword}
          onChange={handleChange}
          error={errors?.currentPassword}
        />
        <Inputz
          iconL="new_password"
          iconR="ok"
          focusR="cal"
          iconOn="eye_on"
          iconOff="eye_off"
          placeholder="New Password"
          type="password"
          name="newPassword"
          value={formData.newPassword}
          onChange={handleChange}
          error={errors?.newPassword}
        />
      </div>
      <div className="form-def-box">
        <Buttonz
          iconR="ok"
          hoverR="ok"
          label="Change Password"
          onClick={handleSubmit}
        />
      </div>
    </>
  );
}

export default SettingPassword;
